import getTilesConfiguration from "@/data/tiles";

export const portfolio_property_name = "Portfolio Property";

function normalize_property_access_key(value) {
    return String(value || "")
        .toLowerCase()
        .replace(/\(live\)/g, "")
        .replace(/[^a-z0-9]+/g, " ")
        .trim();
}

export function get_live_property_names() {
    const configured_tile_names = getTilesConfiguration()
        .filter((tile) => String(tile?.id || "").toLowerCase().includes("(live)"))
        .flatMap((tile) => [tile.title, tile.label, tile.id])
        .filter(Boolean);

    return configured_tile_names
        .filter((property_name, index, all_property_names) => {
            return all_property_names.indexOf(property_name) === index;
        });
}

export function is_live_property(property, live_property_names = get_live_property_names()) {
    const property_name = normalize_property_access_key(property?.name);

    if (!property_name) {
        return false;
    }

    return live_property_names.some((live_property_name) => {
        return normalize_property_access_key(live_property_name) === property_name;
    });
}

export function is_portfolio_property(property) {
    return normalize_property_access_key(property?.name) === normalize_property_access_key(portfolio_property_name);
}

export function filter_live_active_properties(properties) {
    const live_property_names = get_live_property_names();

    return properties.filter((property) => {
        return property.is_active && (is_live_property(property, live_property_names) || is_portfolio_property(property));
    });
}
